import { c as _c } from "react/compiler-runtime";
import { Button, Heading, LayoutStack } from 'design-system/server';
import Image, { StaticImageData } from 'next/image';
import { useTranslations } from 'next-intl';
import styles from '../Error.module.css';
import ErrorXxx from '@/assets/errorXxx.svg';
function GenericError(t0) {
  const $ = _c(28);
  const {
    reset
  } = t0;
  const t = useTranslations("nextjs.errors");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      font: "var(--betterplace-typography-heading-md)"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t) {
    t2 = t("messages.status.xxx.title");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <Heading level="heading-sm" style={t1}>{t2}</Heading>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("messages.status.xxx.reasoning");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4) {
    t5 = <p>{t4}</p>;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3 || $[10] !== t5) {
    t6 = <LayoutStack space="200" className={styles.centeredContainer}>{t3}{t5}</LayoutStack>;
    $[9] = t3;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className={styles.imageContainer}><Image src={ErrorXxx as StaticImageData} alt="" fill={true} priority={true} /></div>;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t) {
    t8 = t("messages.status.xxx.todo_headline");
    $[13] = t;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t8) {
    t9 = <Heading level="heading-xs">{t8}</Heading>;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t) {
    t10 = t("messages.try_again");
    $[17] = t;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== reset || $[20] !== t10) {
    t11 = <div><Button onClick={reset}>{t10}</Button></div>;
    $[19] = reset;
    $[20] = t10;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== t11 || $[23] !== t9) {
    t12 = <LayoutStack space="200" className={styles.centeredContainer}>{t9}{t11}</LayoutStack>;
    $[22] = t11;
    $[23] = t9;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t12 || $[26] !== t6) {
    t13 = <>{t6}{t7}{t12}</>;
    $[25] = t12;
    $[26] = t6;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  return t13;
}
GenericError.displayName = 'GenericError';
export default GenericError;